import Clickable from 'components/Common/Clickable'
import ModalContext from 'contexts/ModalContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import React, { MouseEventHandler, useCallback, useContext } from 'react'
import LoyaltyStayUpgradeBenefitModal from './LoyaltyStayUpgradeBenefitModal'
import LoyaltyTierBenefitPill from './LoyaltyTierBenefitPill'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
}

function LoyaltyStayUpgradeBenefitPill({ offer }: Props) {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)

  const showRoomUpgradesModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<LoyaltyStayUpgradeBenefitModal offer={offer} />)
  }, [showModal, offer])

  return <Clickable onClick={showRoomUpgradesModal}>
    <LoyaltyTierBenefitPill
      kind="secondary"
      tier={tier}
      benefitType="hotel_upgrade"
      endIcon={<LineInfoCircleIcon />}
    >
      Free upgrade with your {getLoyaltyTierDisplayName(tier)} status
    </LoyaltyTierBenefitPill>
  </Clickable>
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(LoyaltyStayUpgradeBenefitPill)
